/**
 * Cài đặt của tiệm cho giao diện: công tắc tính năng (ADR-074) + đặt lịch (N1).
 *
 * Nạp MỘT lần sau đăng nhập, giữ trong bộ nhớ; lưu xong thì báo cho mọi màn đang mở (menu, nút ẩn/hiện
 * ngay, không phải tải lại trang). Hàng rào thật ở máy chủ (`FEATURE_OFF`); ở đây là để ẨN HẲN.
 */
import { boTheoMuc } from '@sapa/shared'
import { useEffect, useState } from 'react'
import { type CaiDatTiem, caiDatApi, type TinhNang } from './api.ts'

let hienTai: CaiDatTiem | null = null
const nguoiNghe = new Set<(c: CaiDatTiem) => void>()

export function datCaiDat(c: CaiDatTiem): void {
  hienTai = c
  for (const f of nguoiNghe) f(c)
}

/** Chưa tải xong → `null` (màn nào cần thì hiện như cũ, không nháy mất rồi hiện lại). */
export function useCaiDatTiem(): CaiDatTiem | null {
  const [c, setC] = useState<CaiDatTiem | null>(hienTai)
  useEffect(() => {
    nguoiNghe.add(setC)
    if (hienTai === null) {
      void caiDatApi
        .doc()
        .then(datCaiDat)
        .catch(() => {
          // Không đọc được: coi như bật hết — thà thừa một nút còn hơn mất chức năng đang dùng.
          datCaiDat({
            tinhNang: boTheoMuc('lon'),
            datLich: {
              tuDatLich: true,
              duyetTay: false,
              mocNhac: 'truoc_24h',
              hanXacNhanPhut: 180,
            },
          })
        })
    }
    return () => {
      nguoiNghe.delete(setC)
    }
  }, [])
  return c
}

/** Đăng xuất / đổi tiệm: quên cài đặt của tiệm cũ. */
export function quenCaiDat(): void {
  hienTai = null
}

/**
 * Tính năng có đang bật không. Chưa tải xong → `true` (hiện như cũ, không nháy mất rồi hiện lại); máy
 * chủ vẫn chặn nếu thật ra đang tắt.
 */
export function useTinhNang(t: TinhNang): boolean {
  return useCaiDatTiem()?.tinhNang[t] !== false
}
